import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CardSetTransformationService, CoreService, DataService, DialogService, FormConfigurationService, SaveDataRequest, SaveFormEvent, SpinnerService } from 'dspx-core';
import { API_ENDPOINTS, API_ENDPOINT_KEYS } from '../../constants/api-endpoints.constants';
import { TEMPLATES, VERSIONS } from '../../constants/templates.constants';
import { AppDataService } from '../../services/app-data.service';
import { ErrorService } from '../../services/error.service';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';
import { NAV_TAB_NUMBERS, PAGE_INDEX, PAGE_NUMBERS, POP_UP_CODES, QUESTION_CODES, REFERENCE_DATA_IDS, SAVE_RESULT_STATUS, SECTION_CODES, SECTION_INDEX, SERVER_ERROR_POP_UP_CODES } from '../../constants/app-data.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { finalize, take } from 'rxjs';

@Component({
  selector: 'app-job-schedule',
  templateUrl: './job-schedule.component.html',
  styleUrl: './job-schedule.component.scss'
})
export class JobScheduleComponent extends BaseCardSetDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  fieldTypeReplacements = CardSetTransformationService.cardSetWithFlatTabsFieldTypeReplacements;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;

  templateId: number = TEMPLATES.jobSchedule;
  versionNo: number = VERSIONS.latest;
  model: any;
  activeDialog: string = '';
  id: string = '';

  private isEditing = false;

  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    protected dialogService: DialogService,
    private coreService: CoreService,
    private spinnerService: SpinnerService,
    private dataService: DataService,
    private errorService: ErrorService,
    private formConfigurationService: FormConfigurationService,
  ) {
    super(router, appDataService, dialogService);
  }

  ngOnInit(): void {
    this.coreService.applicationFunctions = {
    };

    this.coreService.conditionFunctions = {
      alwaysReadOnly: () => true,
      isEditing: () => this.isEditing,
      showInvoicePeriod: () => this.showInvoicePeriod(),
      showEffectiveDate: () => this.showEffectiveDate(),
      showRunDateTime: () => this.isOneOffSchedule(),
      showStartDate: () => this.isRecurringSchedule(),
      showEndDate: () => this.isRecurringSchedule(),
      showRecurringFrequency: () => this.isRecurringSchedule(),
      showRecurringDayOfWeek: () => this.isWeeklyFrequency(),
      showRecurringRunTime: () => this.isRecurringSchedule()
    }

    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      const id = paramMap.get('id');
      if (id) {
        this.id = id;
        this.formServiceEndpoint = API_ENDPOINT_KEYS.getJobScheduleConfigAndResponse;
        this.isEditing = true;
      }
    });
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded(event: any): void {
  }

  modelChanged(event: any): void {
  }

  filter(event: any): void {
  }

  buttonClicked(event: any): void {
  }

  save(event: SaveFormEvent) {
    const saveDataRequest: SaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: event.model,
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: event.isSubmit
    }
    if (!event.isFormValid) {
      this.baseForm.markAllFieldsAsTouched();
      if (!this.baseForm.fields[0]?.formControl.valid) {
        this.baseForm.showValidationSummary(true);
        this.dialogService.showDialog(POP_UP_CODES.common.validationError);
      }
      else {
        this.saveData(saveDataRequest);
      }
    }
    else {
      this.saveData(saveDataRequest);
    }
  }

  cancel(event: any) {
    this.exit();
  }

  dialogButton_saveSuccessful_Clicked(event: any): void {
    this.exit(true);
  }

  private getJobTypeId(): string {
    return this.formConfigurationService.getQuestionResponse(
      this.baseForm.model.form.tabs,
      'tab' + NAV_TAB_NUMBERS.jobScheduleForm.jobSchedule,
      'page' + PAGE_NUMBERS.jobScheduleForm.jobSchedule,
      PAGE_INDEX.noRepeater,
      SECTION_CODES.jobScheduleForm.jobSchedule,
      SECTION_INDEX.noRepeater,
      QUESTION_CODES.jobScheduleForm.jobType
    );
  }

  private getScheduleTypeId(): string {
    return this.formConfigurationService.getQuestionResponse(
      this.baseForm.model.form.tabs,
      'tab' + NAV_TAB_NUMBERS.jobScheduleForm.jobSchedule,
      'page' + PAGE_NUMBERS.jobScheduleForm.jobSchedule,
      PAGE_INDEX.noRepeater,
      SECTION_CODES.jobScheduleForm.jobSchedule,
      SECTION_INDEX.noRepeater,
      QUESTION_CODES.jobScheduleForm.scheduleType
    );
  }

  private getFrequencyTypeId(): string {
    return this.formConfigurationService.getQuestionResponse(
      this.baseForm.model.form.tabs,
      'tab' + NAV_TAB_NUMBERS.jobScheduleForm.jobSchedule,
      'page' + PAGE_NUMBERS.jobScheduleForm.jobSchedule,
      PAGE_INDEX.noRepeater,
      SECTION_CODES.jobScheduleForm.jobSchedule,
      SECTION_INDEX.noRepeater,
      QUESTION_CODES.jobScheduleForm.recurringFrequency
    );
  }

  private showInvoicePeriod() {
    if (this.baseForm?.model?.form?.tabs != null) {
      const jobTypeId = this.getJobTypeId();

      return jobTypeId === REFERENCE_DATA_IDS.jobType.generateCareAllowanceEducationInvoices;
    }

    return false;
  }

  private showEffectiveDate() {
    if (this.baseForm?.model?.form?.tabs != null) {
      const jobTypeId = this.getJobTypeId();

      return jobTypeId === REFERENCE_DATA_IDS.jobType.careAllowancePlacementClientAgeRangeMaintenance
        ||
        jobTypeId === REFERENCE_DATA_IDS.jobType.careAllowancePlacementFinancialYearRateChangeMaintenance;
    }

    return false;
  }

  private isOneOffSchedule() {
    if (this.baseForm?.model?.form?.tabs != null) {
      const scheduleTypeId = this.getScheduleTypeId();

      return scheduleTypeId === REFERENCE_DATA_IDS.jobScheduleType.oneOff;
    }

    return false;
  }

  private isRecurringSchedule() {
    if (this.baseForm?.model?.form?.tabs != null) {
      const scheduleTypeId = this.getScheduleTypeId();

      return scheduleTypeId === REFERENCE_DATA_IDS.jobScheduleType.recurring;
    }

    return false;
  }

  private isWeeklyFrequency() {
    if (this.baseForm?.model?.form?.tabs != null) {
      const frequencyTypeId = this.getFrequencyTypeId();

      return frequencyTypeId === REFERENCE_DATA_IDS.jobFrequencyType.weekly;
    }

    return false;
  }

  private exit(ignoreUnsavedChanges = false): void {
    this.navigate([ROUTE_CONSTANTS.jobSchedule.list], ignoreUnsavedChanges);
  }

  private saveData(request: SaveDataRequest) {
    this.spinnerService.showSpinner();
    this.registerSubscription(
      this.dataService.saveData(API_ENDPOINTS.jobSchedule.save, request)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(data => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            if (SERVER_ERROR_POP_UP_CODES.saveJobSchedule.includes(data.message)) {
              this.activeDialog = data.message;
            }
            else {
              this.id = data.id;
              this.activeDialog = POP_UP_CODES.common.saveSuccessful;
            }
            this.dialogService.showDialog(this.activeDialog);
          }
        })
    );
  }
}
